import { ReactComponent as ArrowRightIcon } from './right.svg';

export default ArrowRightIcon;
